import axios from 'axios';

export function downloadGradeReport(student, { academicYear = '', teacherName = '', period = '10' } = {}) {
  const number = String(student.student_number || student.id).replace(/[^\w-]/g, '_');
  return downloadPdf(`/grades/report/${encodeURIComponent(student.id)}/pdf`, {
    period,
    ...(academicYear ? { academic_year: academicYear } : {}),
    ...(teacherName.trim() ? { teacher_name: teacherName.trim() } : {})
  }, `boleta_${number}_${period === 'all' ? 'anual' : `${period}_semanas`}.pdf`);
}

export function downloadGradeClassReport(grade, academicYear = '', period = '10') {
  return downloadPdf('/grades/reports/by-grade/pdf', {
    grade, period, ...(academicYear ? { academic_year: academicYear } : {})
  }, `boletas_${grade.replace(/[^\w-]/g, '_')}_${period === 'all' ? 'anual' : `${period}_semanas`}.pdf`);
}

async function downloadPdf(path, params, filename) {
  try {
    const { data } = await axios.get(path, { params, responseType: 'blob', timeout: 600000 });
    // Do not save an HTML login/error page with a PDF filename.
    if (!(data instanceof Blob) || (await data.slice(0, 5).text()) !== '%PDF-') {
      throw new Error('No se recibió un PDF válido. Intenta nuevamente.');
    }
    const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    // Safari can consume the URL after the click returns.
    window.setTimeout(() => { link.remove(); window.URL.revokeObjectURL(url); }, 60000);
  } catch (error) {
    let detail = error.message || 'Error al descargar la boleta';
    const body = error.response?.data;
    if (body) {
      try { detail = (body instanceof Blob ? JSON.parse(await body.text()) : body).detail || detail; } catch (_) {}
    }
    throw new Error(typeof detail === 'string' ? detail : 'Error al descargar la boleta');
  }
}
